import { type EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import Honeybadger from '@honeybadger-io/js';
import { Environment } from '@td/core';

export const googleMapsInitializer = (): EnvironmentProviders =>
  provideAppInitializer(() => {
    const environment = inject(Environment);
    if (!window.loadGoogleMap) {
      Honeybadger.notify('Load Google Maps script failed.');
      return;
    }
    window.loadGoogleMap({ v: 'weekly', key: environment.googleApiKey });
  });
